import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core'
import { GuardianInvite } from '@se-po/shared-data-access-models'
import { AddGuardianComponent } from '@se-po/shared-ui-add-guardian'
import { Persona } from 'se-resource-types/dist/lib/CentralService/Profiles'

@Component({
  selector: 'se-po-invite',
  templateUrl: './invite.component.html',
  styleUrls: ['./invite.component.scss'],
  standalone: false,
})
export class InviteComponent {
  @Input() public persona: Persona
  @Output() public inviteAdded: EventEmitter<GuardianInvite> = new EventEmitter()
  @Output() public inviteSkipped: EventEmitter<void> = new EventEmitter()
  @ViewChild('addGuardian') public addGuardian: AddGuardianComponent

  public translationKey = 'SE_PO_SE_PERSONA_PICKER_FEATURE_ADD_GUARDIAN_MODAL.'

  public onInvite(): void {
    if (this.addGuardian.isValid()) {
      this.inviteAdded.emit(this.addGuardian.value)
    }
  }

  public onSkip(): void {
    this.inviteSkipped.emit()
  }
}
